import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { GitBranch } from 'lucide-react';
import { useTickets } from '../contexts/TicketsProvider';

function Clock() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  const pad = (n) => String(n).padStart(2, '0');
  return <span className="tabular-nums">{pad(now.getHours())}:{pad(now.getMinutes())}:{pad(now.getSeconds())}</span>;
}

// VS Code / vim-style status line, pinned to the bottom of the main column.
export default function StatusBar() {
  const { visibleTickets, summary, scope } = useTickets();
  const location = useLocation();
  const view = location.pathname.replace('/', '') || 'board';
  const overdue = summary.overdue;

  return (
    <footer className="sticky bottom-0 z-10 flex items-center justify-between gap-4 border-t border-border bg-card/80 px-3 py-1 text-xs text-muted-foreground backdrop-blur">
      <div className="flex items-center gap-3">
        <span className="flex items-center gap-1 rounded bg-primary/15 px-1.5 py-0.5 font-medium text-primary">
          <GitBranch className="h-3 w-3" /> main
        </span>
        <span className="hidden sm:inline">~/ticky/{view}</span>
        <span className="rounded bg-muted px-1.5 py-0.5">scope:{scope}</span>
      </div>
      <div className="flex items-center gap-3">
        <span className="hidden sm:inline">tickets:<span className="text-foreground">{visibleTickets.length}</span></span>
        <span>open:<span className="text-foreground">{summary.open}</span></span>
        {summary.estimate_hours > 0 ? (
          <span className="hidden sm:inline" title="estimated hours of open tickets">est:<span className="text-foreground">{summary.estimate_hours}h</span></span>
        ) : null}
        <span className={overdue ? 'text-red-500' : ''}>
          overdue:<span className={overdue ? 'font-semibold' : 'text-foreground'}>{overdue}</span>
        </span>
        <span className="hidden text-muted-foreground/50 md:inline">utf-8 · LF · mono</span>
        <Clock />
      </div>
    </footer>
  );
}
